import React, { useEffect, useState } from "react";
import { Predicates, SortDirection, DataStore } from 'aws-amplify';
import { Farm } from '../../models';
import { StyleSheet, Text, ScrollView, TouchableOpacity, View, SafeAreaView } from 'react-native';
import { Link } from "@react-navigation/native";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import { googleMapsApiKey } from "../components/AppConst";
import { getCurrentUser, varietiesCnv } from "../components/CmnUtil";
import { Header } from "../components/Header";

/** ================================
*  圃場一覧画面
*  ================================*/
const FarmList = ({ navigation }: { navigation: any; }) => {

  // 圃場のデータを格納するステート
  const [farmData, setFarmData] = useState<Farm[]>([]);

  // 圃場のデータをセット
  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      // 情報読出
      fetchFarm();
    });
    fetchFarm();
    return () => {
      unsubscribe();
    };
  }, []);

  // 情報読出
  const fetchFarm = async () => {
    const appUser = await getCurrentUser();
    const farms = (await DataStore.query(Farm, Predicates.ALL, {
      sort: s => s.createdAt(SortDirection.ASCENDING),
    })).filter(c => c.group.id == appUser?.group.id);;

    setFarmData(farms);
  };

  // googleMap
  const GMap = ({ farm }: { farm: Farm; }) => {
    const { isLoaded, loadError } = useJsApiLoader({
      googleMapsApiKey: googleMapsApiKey,
    });

    const RenderMap = () => {
      return (<GoogleMap
        mapContainerStyle={{ width: "100%", height: "220px", }}
        center={{ lat: farm.lat, lng: farm.lng }}
        zoom={18}
        options={{
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          mapTypeId: "hybrid",
          gestureHandling: "none",
          keyboardShortcuts: false,
        }}
      >
        <Marker position={{ lat: farm.lat, lng: farm.lng }} />
      </GoogleMap>
      );
    };
    if (loadError) {
      return <Text>Map cannot be loaded right now, sorry.</Text>;
    };

    return isLoaded ? <RenderMap /> : <Text>loading...</Text>;
  };

  // 1圃場のコンポーネントを作成
  const FarmItem = ({ farm }: { farm: Farm; }) => {
    const tmpVarieties = [];
    if (farm.varieties) {
      for (const variety of farm.varieties) {
        if (variety) {
          tmpVarieties.push(varietiesCnv(variety));
        }
      }
    }

    return (
      <View style={styles.farmItem} >

        {/* グーグルマップ */}
        <GMap farm={farm} />

        <Text
          style={styles.farmName}
          numberOfLines={1}
          ellipsizeMode={"tail"}
        >{farm.name}</Text>
        <Text
          style={styles.farmVarieties}
          numberOfLines={1}
          ellipsizeMode={"tail"}
        >{tmpVarieties.join("・")}</Text>
        <Text
          style={styles.farmMemo}
          numberOfLines={1}
          ellipsizeMode={"tail"}
        >{farm.memo}</Text>
        <View style={styles.linkWrap}>
          <Link style={styles.link} to={{ screen: "FarmDetail", params: { id: farm.id } }}>圃場情報を変更する</Link>
        </View>
      </View>
    );
  };

  // 各圃場のコンポーネントを表示するコンポーネントを作成
  const FarmItems = () => {
    return (
      <ScrollView style={styles.farmItemContainer}>
        {farmData.map((farm, key) =>
          <FarmItem farm={farm} key={key} />
        )}
        <TouchableOpacity style={styles.createFarm} onPress={() => navigation.navigate("FarmDetail")}>
          <Text style={styles.createFarmText} >+  新規圃場登録</Text>
        </TouchableOpacity>
      </ScrollView>
    );
  };

  return (
    <SafeAreaView style={styles.container}>
      <Header onPress={() => navigation.goBack()} goBackText={"＜"} headerText={"圃場管理"} />
      <FarmItems />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#E2F0D9",
  },
  farmItemContainer: {
    paddingBottom: 20
  },
  farmItem: {
    position: "relative",
    width: "90%",
    height: 380,
    backgroundColor: "#ffffff",
    paddingTop: 20,
    paddingHorizontal: 10,
    paddingBottom: 5,
    alignItems: "center",
    marginBottom: 20,
    marginHorizontal: "auto",
    shadowColor: "#808080",
    shadowOffset: { width: 5, height: 5 },
    shadowRadius: 10
  },
  farmName: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 20,
    marginBottom: 5,
  },
  farmVarieties: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 18,
    marginBottom: 5,
  },
  farmMemo: {
    textAlign: "center",
    fontSize: 18,
  },
  linkWrap: {
    position: "absolute",
    bottom: 5,
    right: 5,
  },
  link: {
    textDecorationLine: "underline",
    fontSize: 18,
  },
  createFarm: {
    width: "90%",
    height: 56,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ffffff",
    shadowColor: "#808080",
    shadowOffset: { width: 5, height: 5 },
    shadowRadius: 10,
    marginHorizontal: "auto"
  },
  createFarmText: {
    fontSize: 18
  }
});

export default FarmList;